<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PURCHASEPRICE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PURCHASEPRICE),
      }"
    >
      <mat-label>Purchase Price</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.PURCHASEPRICE.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PURCHASEPRICE"
        (focusout)="calcBalance()"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.PURCHASEPRICE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PURCHASEPRICE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PURCHASEPRICE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEPOSITTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEPOSITTYPE),
      }"
    >
      <mat-label>Deposit Type</mat-label>
      <mat-select
        matTooltip="{{ toolTipList ? toolTipList.DEPOSITTYPE.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DEPOSITTYPE"
      >
        @for (optionval of DepositType; track optionval) {
          <mat-option value="{{ optionval.LOOKUPFULLVALUE }}">
            {{ optionval.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-select>
      @if (testBool && toolTipList.DEPOSITTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DEPOSITTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DEPOSITTYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INITIALDEPOSIT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INITIALDEPOSIT),
      }"
    >
      <mat-label>Initial Deposit</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.INITIALDEPOSIT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="INITIALDEPOSIT"
        (focusout)="calcBalance()"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.INITIALDEPOSIT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.INITIALDEPOSIT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.INITIALDEPOSIT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BALANCEDEPOSIT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BALANCEDEPOSIT),
      }"
    >
      <mat-label>Balance Deposit</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.BALANCEDEPOSIT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BALANCEDEPOSIT"
        (focusout)="calcBalance()"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.BALANCEDEPOSIT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BALANCEDEPOSIT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BALANCEDEPOSIT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BALANCEDEPOSITDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BALANCEDEPOSITDATE),
      }"
    >
      <mat-label>Balance of Deposit Due</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'BALANCEDEPOSITDATE')"
        matTooltip="{{ toolTipList ? toolTipList.BALANCEDEPOSITDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BALANCEDEPOSITDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'BALANCEDEPOSITDATE')"
        matInput
        name="BalanceofDepositDue"
        [matDatepicker]="BalanceofDepositDue"
      />
      <mat-datepicker-toggle matSuffix [for]="BalanceofDepositDue"></mat-datepicker-toggle>
      <mat-datepicker #BalanceofDepositDue></mat-datepicker>
      @if (testBool && toolTipList.BALANCEDEPOSITDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BALANCEDEPOSITDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.BALANCEDEPOSITDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEPOSITBONDAMOUNT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEPOSITBONDAMOUNT),
      }"
    >
      <mat-label>Deposit Bond</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.DEPOSITBONDAMOUNT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DEPOSITBONDAMOUNT"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.DEPOSITBONDAMOUNT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEPOSITBONDEXPIRYDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEPOSITBONDEXPIRYDATE),
      }"
    >
      <mat-label>Deposit Bond Expiry Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'DEPOSITBONDEXPIRYDATE')"
        matTooltip="{{ toolTipList ? toolTipList.DEPOSITBONDEXPIRYDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DEPOSITBONDEXPIRYDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'DEPOSITBONDEXPIRYDATE')"
        matInput
        name="DepositBondExpiryDate"
        [matDatepicker]="DepositBondExpiryDate"
      />
      <mat-datepicker-toggle matSuffix [for]="DepositBondExpiryDate"></mat-datepicker-toggle>
      <mat-datepicker #DepositBondExpiryDate></mat-datepicker>
      @if (testBool && toolTipList.DEPOSITBONDEXPIRYDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DEPOSITBONDEXPIRYDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DEPOSITBONDEXPIRYDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEPOSITAMOUNT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEPOSITAMOUNT),
      }"
    >
      <mat-label>Deposit Amount</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.DEPOSITAMOUNT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DEPOSITAMOUNT"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.DEPOSITAMOUNT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DEPOSITAMOUNT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DEPOSITAMOUNT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BALANCEVAL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BALANCEVAL),
      }"
    >
      <mat-label>Balance</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        class="sideText"
        matTooltip="{{ toolTipList ? toolTipList.BALANCEVAL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BALANCEVAL"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.BALANCEVAL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BALANCEVAL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BALANCEVAL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.GST),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.GST),
      }"
    >
      <mat-label>GST</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.GST?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="GST"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.GST) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.GST.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.GST?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.OTHERCONSIDERATION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.OTHERCONSIDERATION),
      }"
    >
      <mat-label>Other Consideration</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.OTHERCONSIDERATION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="OTHERCONSIDERATION"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.OTHERCONSIDERATION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OTHERCONSIDERATION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.OTHERCONSIDERATION?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Seller's Agent Commission</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        formControlName="SELLERAGENTSCOMMISSION"
        [leadZero]="true"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Buyer's Agent Commission</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        formControlName="BUYERAGENTSCOMMISSION"
        [leadZero]="true"
      />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Settlement Fee</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        formControlName="SETTLEMENTFEE"
        [leadZero]="true"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>ELNO/PEXA Fee</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        formControlName="PEXAFEE"
        [leadZero]="true"
      />
    </mat-form-field>
  </div>

  <div fxLayout="row" class="checkbox-row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox class="checkbox-width" formControlName="REQUIRESLOANDISCHARGE">
      Requires Loan Discharge
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="INVESTDEPOSIT">
      Invest Deposit
    </mat-checkbox>
  </div>
</div>
